export const getPriceWithoutVat = (priceWithVat: number, vatRate: number) => {
  return Math.round(priceWithVat / (100 + vatRate) * 100 * 100) / 100;
};


// WEBPACK FOOTER //
// ../data-layer/src/helpers/prices/getPriceWithoutVat.ts